import noop from 'lodash/noop';
import { Component } from 'react';

import { Logger } from '@farmersdog/logger';
import { browserOnly } from '@farmersdog/utils';

import { NotFound } from '../NotFound';

import type { ReactNode, ErrorInfo } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

interface ErrorLogger {
  error: typeof Logger.prototype.error;
}

class ErrorBoundary extends Component<Props, State> {
  private logger: ErrorLogger;

  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
    this.logger = browserOnly(
      () => new Logger('content-error-boundary'),
      () => ({ error: noop })
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public static getDerivedStateFromError(_: Error) {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, info: ErrorInfo) {
    this.logger.error(error.message, { errorInfo: info });
  }

  public render() {
    if (!this.state.hasError) {
      return this.props.children;
    }
    return <NotFound />;
  }
}

export default ErrorBoundary;
